import axios from "@/plugins/axios";

export function getArchives() {
  return axios({
    url: "Article/GetArchiveDataAsync",
    method: "GET",
  });
}
